(function waitForSelecty() {
  const observer = new MutationObserver(() => {
    const host = document.querySelector('.sel-outer');
    if (host && host.shadowRoot) {
      const shadow = host.shadowRoot;

      const style = document.createElement('style');
      style.textContent = `
        .sel-itemsList .sel-item-hidden {
          display: none !important;
        }
      `;
      shadow.appendChild(style);
      console.log('✅ <style> 已注入到 shadow DOM');

      observer.disconnect(); // 找到后停止监听
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
